import { SET_SMART_BANNER, SET_SPLASHSCREEN_VIEW } from '../../constants';
export function setSplashScreenView(showSplashScreen) {
    return {
        type: SET_SPLASHSCREEN_VIEW,
        showSplashScreen,
    };
}
export function setSmartBanner(showSmartBanner) {
    return {
        type: SET_SMART_BANNER,
        showSmartBanner,
    };
}
